import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallBanner = () => {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem("install_dismissed") === "1") return;
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (!show) return null;
  const dismiss = () => { localStorage.setItem("install_dismissed", "1"); setShow(false); };
  const install = async () => { if (!prompt) return; prompt.prompt(); const { outcome } = await prompt.userChoice; if (outcome === "accepted") setShow(false); };

  return (
    <div className="mx-4 mt-3 lg:mx-0 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-3 py-2.5 flex items-center gap-3 text-xs text-emerald-100" data-testid="install-banner">
      <img src="/icon-192.png" alt="" className="w-8 h-8 rounded-lg" />
      <div className="flex-1 min-w-0">
        <p className="font-semibold">Install NextProfit on your home screen</p>
        {prompt ? <p className="text-emerald-200/80">Full-screen app, faster launch, alerts.</p>
          : <p className="text-emerald-200/80 flex items-center gap-1 flex-wrap">Tap <Share className="w-3.5 h-3.5 inline" /> Share, then <b>Add to Home Screen</b>.</p>}
      </div>
      {prompt && <button onClick={install} className="shrink-0 rounded-lg bg-emerald-500 text-[#07090E] font-semibold px-3 py-1.5 flex items-center gap-1" data-testid="install-button"><Download className="w-3.5 h-3.5" /> Install</button>}
      <button onClick={dismiss} className="shrink-0 text-emerald-200/70 hover:text-white" aria-label="Dismiss" data-testid="install-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
};
